/* TriggerNode — Custom React Flow node for trigger type */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import css from '../../AutomationEditor.module.css';
import NodeIcon from './NodeIcon';

export default memo(function TriggerNode({ data, selected }: NodeProps) {
  const color = (data.color as string) || '#f59e0b';

  return (
    <div
      className={`${css.customNode}${selected ? ` ${css.selected}` : ''}`}
      style={{ borderColor: color }}
    >
      <div className={css.nodeHeader}>
        <div className={css.nodeIcon} style={{ background: color }}>
          <NodeIcon icon={(data.icon as string) || '⚡'} />
        </div>
        <div>
          <div className={css.nodeLabel}>{data.label as string}</div>
          <div className={css.nodeType}>Trigger</div>
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} id="default" />
    </div>
  );
});
